import {
  BROWSER_LOGIN_HANDOFF_TOOL_NAME,
  type BrowserLoginHandoffInput,
  type BrowserLoginHandoffResolution,
} from '@newfront-insurance/ai-api';
import type { ToolUIPart } from 'ai';

export { BROWSER_LOGIN_HANDOFF_TOOL_NAME };
export type { BrowserLoginHandoffInput, BrowserLoginHandoffResolution };

type BrowserLoginHandoffUITools = {
  browserLoginHandoff: {
    input: BrowserLoginHandoffInput;
    output: BrowserLoginHandoffResolution;
  };
};

export type BrowserLoginHandoffToolPart = ToolUIPart<BrowserLoginHandoffUITools>;

export function isBrowserLoginHandoffToolPart(part: { type: string }): part is BrowserLoginHandoffToolPart {
  return part.type === `tool-${BROWSER_LOGIN_HANDOFF_TOOL_NAME}`;
}

export function isResolvedBrowserLoginHandoff(
  output: BrowserLoginHandoffResolution | undefined,
): output is BrowserLoginHandoffResolution {
  return output?.action === 'continue' || output?.action === 'cancel';
}
